<template>
  <div>
    <div v-if="data.column.field === 'accountId'" class="d-flex align-items-center">
      <span>{{ data.row.accountId }}</span>
    </div>
    <div v-if="data.column.field === 'accountName'" class="d-flex align-items-center">
      <span>{{ data.row.accountName }}</span>
    </div>
    <div v-if="data.column.field === 'displayAdsViews'" class="d-flex align-items-center">
      <span>{{ formatNumber(data.row.displayAdsViews) }}</span>
    </div>
    <div v-if="data.column.field === 'displayAdsClicks'" class="d-flex align-items-center">
      <span>{{ formatNumber(data.row.displayAdsClicks) }}</span>
    </div>
    <div v-if="data.column.field === 'displayActions'" class="d-flex align-items-center">
      <span>{{ formatNumber(data.row.displayActions) }}</span>
    </div>
    <div v-if="data.column.field === 'displayAdsCTR'" class="d-flex align-items-center">
      <span>{{ formatNumber(data.row.displayAdsCTR) }}</span>
    </div>
    <div v-if="data.column.field === 'videoViews'" class="d-flex align-items-center">
      <span>{{ formatNumber(data.row.videoViews) }}</span>
    </div>
    <div v-if="data.column.field === 'videoActions'" class="d-flex align-items-center">
      <span>{{ formatNumber(data.row.videoActions) }}</span>
    </div>
    <div v-if="data.column.field === 'videoClicks'" class="d-flex align-items-center">
      <span>{{ formatNumber(data.row.videoClicks) }}</span>
    </div>
    <div v-if="data.column.field === 'nativeAdViews'" class="d-flex align-items-center">
      <span>{{ formatNumber(data.row.nativeAdViews) }}</span>
    </div>
    <div v-if="data.column.field === 'nativeAdClicks'" class="d-flex align-items-center">
      <span>{{ formatNumber(data.row.nativeAdClicks) }}</span>
    </div>
    <div v-if="data.column.field === 'period'" class="d-flex align-items-center">
      <span>{{ data.row.period }}</span>
    </div>
    <div v-if="data.column.field === 'filePath'" class="d-flex align-items-center">
      <b-link @click.prevent="handleDownload">
        {{ $tk('ClientPortal.Admin.ClickToViewFile') }}
      </b-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    downloadFile: {
      type: Function,
      required: true,
    },
  },
  methods: {
    formatNumber(value) {
      return Number(value).toLocaleString()
    },
    handleDownload() {
      this.downloadFile(this.data.row)
    },
  },
}
</script>

<style scoped lang="scss">
</style>
